import { type Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class LevumiItemFilter extends AdornisFilter {
  static override _class = 'LevumiItemFilter';

  override searchFields: Maybe<string[]> = ['sentence', 'mathFunction'];

  override getMongoFilter(): Record<string, any> {
    const filter = super.getMongoFilter();

    // TODO (good first issue) we probably also want to regex search over the item. The problem is that "item" is a number.
    if (filter?.$and?.length && this.search) {
      filter.$and[0].$or.push({
        item: parseInt(this.search),
      });
    }

    return filter;
  }
}
